import { v4 as uuidv4 } from 'uuid';
import {
  createConfig,
  deleteConfig,
  getConfig,
  getConfigByTypeKey,
  getConfigs,
  updateConfig,
} from "./configurationService";

const TYPE = "presentation";
const viewScope = [
  "owner",
  "admin",
  "prompt-engineer",
  "clinical-author",
  "demonstrator",
  "viewer",
];
const editScope = [
  "owner",
  "admin",
  "prompt-engineer",
  "clinical-author",
  "demonstrator",
];
const deleteScope = [
  "owner",
  "admin",
  "prompt-engineer",
  "clinical-author",
  "demonstrator",
];

export const presentationService = {
  create: async ({ key, value }) => {
    const data = await createConfig(
      TYPE,
      key,
      JSON.stringify(value),
      null,
      null,
      viewScope,
      editScope,
      deleteScope
    );
    return {
      ...value,
      id: data.id,
      key: data.key,
    };
  },

  list: async () => {
    const results = await getConfigs(TYPE);
    const items =
      results.map((result) => {
        let value = JSON.parse(result.value);
        if (typeof value === "string") {
          value = { name: value };
        }
        value.id = result.id;
        value.key = result.key;
        return value;
      }) ?? [];
    return items.sort((a, b) => a.name.localeCompare(b.name));
  },

  getById: async (id, throw404 = false) => {
    try {
      const result = await getConfig(id);
      const value = JSON.parse(result.value);
      value.id = result.id;
      value.key = result.key;
      return value;
    } catch (e) {
      if (throw404 && e.response && e.response.status === 404) {
        throw e;
      }
    }
    return null;
  },

  getByUrlName: async (urlName, throw404 = false) => {
    try {
      const results = await presentationService.list();
      return results.find(p => p.url_name === urlName);
    } catch (e) {
      if (throw404 && e.response && e.response.status === 404) {
        throw e;
      }
    }
    return null;
  },

  getByKey: async (key, throw404 = false) => {
    try {
      const result = await getConfigByTypeKey(TYPE, key);
      const value = JSON.parse(result.value);
      value.id = result.id;
      value.key = result.key;
      return value;
    } catch (e) {
      if (throw404 && e.response && e.response.status === 404) {
        throw e;
      }
    }
    return null;
  },

  update: async ({ id, value }) => {
    const existing = await getConfig(id);
    if (!existing) {
      throw new Error("Object does not exist");
    }
    return await updateConfig(id, TYPE, existing.key, JSON.stringify(value));
  },

  delete: async (id) => {
    const existing = await getConfig(id);
    if (existing) {
      return await deleteConfig(id);
    }
    return null;
  },

  duplicate: async (id) => {
    const existing = await getConfig(id);
    if (existing) {
      const value = JSON.parse(existing.value);
      const newKey = uuidv4();
      const newName = `Copy of ${value.name}`;
      return await createConfig(
        TYPE,
        newKey,
        JSON.stringify({
          ...value,
          name: newName,
        }),
        null,
        null,
        viewScope,
        editScope,
        deleteScope
      );
    }
    return null;
  },
};

export default presentationService;
